module.exports = __webpack_public_path__ + "static/media/stone4_1.bfc3e882.gif";